import { Outlet, useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        const scrollContainers = document.querySelectorAll("main, .main, .container, .page, .content");
        scrollContainers.forEach((el) => {
            el.scrollTop = 0;
        });
    
    }, [location.pathname]);

    return (
        <>
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </>
    );
};

export default Layout;
